import { FC, useState } from 'react'
import * as R from 'ramda'

import { gqlDisplayName } from 'shared/lib/user'

import Popover from 'src/components/generics/menus/next-popover'
import { UsernameMenuContent } from './menu-content'
import { UserMenuType } from '../types'

interface UsernameMenuProps {
  user: UserMenuType
  className?: string
  messageEnabled: boolean
  isOwnProfile: boolean
}

export const UsernameMenu: FC<UsernameMenuProps> = ({
  user,
  messageEnabled,
  isOwnProfile
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => {
    setMenuOpen(R.not)
  }
  const openMenu = () => setMenuOpen(true)
  const closeMenu = () => setMenuOpen(false)

  const displayName = gqlDisplayName(user)
  return (
    <Popover
      open={menuOpen}
      onHover={openMenu}
      placement="bottom"
      onRequestClose={closeMenu}
      afterClose={undefined}
      renderTrigger={({ ...triggerProps }) => (
        <button
          {...triggerProps}
          onClick={toggleMenu}
          className="text-blue-600">
          {displayName}
        </button>
      )}>
      <UsernameMenuContent
        user={user}
        messagesEnabled={messageEnabled}
        isOwnProfile={isOwnProfile}
      />
    </Popover>
  )
}
